import React, { Component } from 'react';
import { connect } from 'react-redux';
import threeEntryPoint from '../threejs/three-entry-point';
import { setActiveFeature, resetActiveFeature, resetFeatureMap, setObjectPosition, resetObjectPosition } from '../actions';
import * as ReactGA from 'react-ga';

class ThreeDModel extends Component {

    constructor(props){
        super(props);

        this.positionTicker = null;

        this._onModelClick = this._onModelClick.bind(this);
        this._onModelMouseDown = this._onModelMouseDown.bind(this);
        this._setFeaturePosition = this._setFeaturePosition.bind(this);
    }

    componentDidMount() {
        this.model = new threeEntryPoint( this.modelDiv, this.props.bacteria );
    }

    componentDidUpdate( prevProps ) {
        const { bacteria, activeFeature, resetObjectPosition } = this.props;

        // Update camera position if the active feature has changed.
        if( prevProps.activeFeature !== activeFeature && activeFeature !== null ){
            if( bacteria.features[activeFeature].cameraPos !== undefined && bacteria.features[activeFeature].cameraPos !== null ){
                this.model.moveCameraTo(bacteria.features[activeFeature]);

                this.positionTicker = setTimeout( () => {
                    this._setFeaturePosition(bacteria.features[activeFeature]);
                },1000);
            }else{
                clearTimeout( this.positionTicker );
                resetObjectPosition();
            }
        }else{
            resetObjectPosition();
        }
    }

    _setFeaturePosition ( feature ) {
        const { setFeaturePosition } = this.props;
        const posInCanvas = this.model.getFeaturePosition( feature );

        const windowOffest = this.modelDiv.getBoundingClientRect();
        const posInWindowX = posInCanvas.x + windowOffest.left;
        const posInWindowY = posInCanvas.y + windowOffest.top;

        setFeaturePosition(posInWindowX,posInWindowY);
    }

    _onModelClick( e ) {
        const { openFeature } = this.props;
        const featureKey = this.model.clickLocator(e.nativeEvent.clientX, e.nativeEvent.clientY);
        if( featureKey !== undefined ){
            // Waiting for camera movement.
            setTimeout( () => {
                openFeature(featureKey);
            },1000);
        }
    }

    _onModelMouseDown() {
        const { closeFeatures } = this.props;
        closeFeatures();

        ReactGA.event({
           category: 'Bacteria',
           action: 'Model Interacted'
        });
    }

    render() {
        return(
            <div className="threed-model-container" onMouseDown={ this._onModelMouseDown } onTouchStart={ this._onModelMouseDown } onClick={ this._onModelClick } ref={ (modelDiv) => { this.modelDiv = modelDiv } } />
        );
    }

}

const mapStateToProps = ( state ) => {
    return {
        activeFeature: state.activeFeature
    }
};

const mapDispatchToProps = ( dispatch ) => {
    return{
        openFeature: ( featureKey ) => {
            dispatch(setActiveFeature(featureKey));
        },
        closeFeatures: () => {
            dispatch(resetActiveFeature());
            dispatch(resetFeatureMap());
        },
        setFeaturePosition: ( x, y ) => {
            dispatch(setObjectPosition(x,y));
        },
        resetObjectPosition: () => {
            dispatch( resetObjectPosition() );
        }
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(ThreeDModel);



// WEBPACK FOOTER //
// ./src/components/3d-model.js